module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.element_id,
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-create-template",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.element_options.title))]), _c('span', {
    staticClass: "modal-subtitle"
  }, [_vm._v(_vm._s(_vm.element_options.subtitle))])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('template-form', {
    ref: "template_form",
    staticClass: "internal-scroller",
    attrs: {
      "id": _vm.form_id,
      "options": _vm.form_options,
      "template": _vm.template_or_default,
      "default_template_kind": _vm.template_kind
    },
    on: {
      "validation-success": _vm.saveTemplate
    }
  })], 1), _c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-gray",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Voltar")]), (_vm.element_options.delete_button) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_vm._v("Excluir")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.element_options.disable_buttons
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Salvar")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60c6dd68!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/create_modal.vue
// module id = 1144
// module chunks = 1